import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock, FiFacebook, FiInstagram } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-[#2c3e50] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/">
              <img src="https://i.imgur.com/cgUaH6L.png" alt="AUTOSFERSAN Logo" className="h-12 mb-4" />
            </Link>
            <p className="text-gray-300 mb-4">
              Tu concesionario de confianza en Cáceres. Especialistas en vehículos de segunda mano con garantía y calidad.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-[#3498db] transition-colors">
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-[#3498db] transition-colors">
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/catalogo" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  Catálogo
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-[#3498db] mt-0.5" />
                <span className="text-gray-300 text-sm">
                  Calle Isaac Peral, 31<br />
                  Polígono La Mejostilla<br />
                  10004, Cáceres
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-[#3498db]" />
                <a href="tel:610701517" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  610 70 15 17
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-[#3498db]" />
                <a href="mailto:info@autosfersan.com" className="text-gray-300 hover:text-[#3498db] transition-colors">
                  info@autosfersan.com
                </a>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Horario</h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-[#3498db]" />
                <span className="text-gray-300 text-sm">Lunes - Viernes</span>
              </div>
              <p className="text-gray-300 text-sm ml-7">9:00 - 14:00 | 16:00 - 19:00</p>
              <div className="flex items-center space-x-2 mt-2">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-[#3498db]" />
                <span className="text-gray-300 text-sm">Sábados</span>
              </div>
              <p className="text-gray-300 text-sm ml-7">9:00 - 14:00</p>
            </div>
          </div>
        </div>

        <hr className="my-8 border-gray-600" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 AUTOSFERSAN. Todos los derechos reservados.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/privacidad" className="text-gray-400 hover:text-[#3498db] text-sm transition-colors">
              Política de Privacidad
            </Link>
            <Link to="/legal" className="text-gray-400 hover:text-[#3498db] text-sm transition-colors">
              Aviso Legal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;